import React from "react";
import logo from "../../public/assets/images/logo.png";
import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import Spinner from "./../../components/Spinner/Spinner";
import axios from "./../../axios";
import siteUrl from '../../config'
import utils from "../../utils/index";

class Signin extends React.Component {
    state = {
        /*formData: { email: "", password: "" },*/ formSubmitting: false,
        error: null,
        showpass: true,
    };

    validateScema = Yup.object().shape({
        email: Yup.string()
            .email("E-Mail not valid.")
            .required("E-Mail is required.")
            .trim(),
        password: Yup.string().required("Password is required.").min(6),
    });

    //   updateFormData = (e) => {
    //     let name = e.target.name;
    //     let value = e.target.value;
    //     this.setState((formData) => {
    //       return { ...formData, [name]: value };
    //     });
    //   };
    loginHandler = (data) => {
        // alert(JSON.stringify(data, null, 2));
        axios
            .post("/login", data)
            .then((res) => {
                console.log("Login Response", res)
                const data = res.data._metadata;
                const message = data.message;
                const outcome = data.outcome;
                if (outcome === "LOGIN_FAILED") {
                    this.setState((state) => {
                        return {
                            formSubmitting: false,
                            error: message,
                        };
                    });
                } else {
                    const userRole = res.data.records.student.user_role_name;
                    const access_token = res.data.records.student.access_token;
                    const name = res.data.records.student.first_name + " " + res.data.records.student.last_name;
                    localStorage.setItem('access_token', access_token);
                    localStorage.setItem('role', userRole);
                    localStorage.setItem('name', name);

                    if (userRole === "schooladmin") {
                        utils.redirectWithToken(siteUrl.sadmin_url, access_token, userRole);
                    } else if (userRole === "student") {
                        utils.redirectWithToken(siteUrl.student_url, access_token, userRole);
                    } else {
                        alert("Invalid User Role");
                    }
                    this.setState((state) => {
                        return {
                            formSubmitting: false,
                            error: null,
                        };
                    });
                }
            })
            .catch((err) => {
                console.log("err = ", {err});
                this.setState((state) => {
                    return {
                        formSubmitting: false,
                        error: err.message,
                    };
                });
            });
    };

    clearErrorHandler = () => {
        this.setState({error: null});
    };

    showpass() {
        this.setState({showpass: !this.state.showpass});
    }

    render() {

        let {showpass} = this.state
        return (
            <React.Fragment>
                <div className="account-wrap signin">
                    <div className="logo">
                        <a href="javascript:void(0)">
                            <img src={logo} alt=""/>
                        </a>
                    </div>
                    <div className="container position-relative">
                        <div className="row">
                            <div className="col-sm-7 offset-sm-5">
                                <div className="account-form-wrap form-signup">
                                    <div className="account-title">
                                        <h3>Student Login</h3>
                                        <p>Enter your details below</p>
                                    </div>

                                    {this.state.error && (
                                        <div
                                            className="alert alert-danger alert-dismissible fade show"
                                            role="alert"
                                        >
                                            {this.state.error}
                                            <button
                                                type="button"
                                                className="close"
                                                data-dismiss="alert"
                                                aria-label="Close"
                                                onClick={this.clearErrorHandler}
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    )}
                                    <Formik
                                        initialValues={{
                                            email: "",
                                            password: "",
                                        }}
                                        validationSchema={this.validateScema}
                                        onSubmit={(data) => {
                                            //   alert(JSON.stringify(data, null, 2));
                                            this.setState((state) => {
                                                return {
                                                    formSubmitting: !state.formSubmitting,
                                                };
                                            });
                                            this.loginHandler(data);
                                        }}
                                    >
                                        {({values, errors, touched}) => (
                                            <Form>
                                                <div className="form-floating no-icon">
                                                    <div className="form-row">
                                                        <div className="form-group col-sm-8">
                                                            <label>Email address*</label>
                                                            <Field
                                                                type="text"
                                                                name="email"
                                                                autoComplete="email"
                                                                className="form-control"
                                                            />
                                                            {errors.email && touched.email && (
                                                                <span className="invalid-feedback d-block">
                                  {errors.email}
                                </span>
                                                            )}
                                                        </div>
                                                        <div className="form-group col-sm-8">
                                                            <div
                                                                className={
                                                                    showpass
                                                                        ? "passwordContainer show"
                                                                        : "passwordContainer"
                                                                }
                                                            >
                                <span
                                    className="showPasswordIcon"
                                    onClick={() => {
                                        this.showpass();
                                    }}
                                >
                                  <i className="far fa-eye-slash"> </i>
                                </span>
                                                                <label>Password*</label>
                                                                <Field
                                                                    type="password"
                                                                    name="password"
                                                                    autoComplete="new-password"
                                                                    className="form-control"
                                                                />
                                                                {errors.password && touched.password && (
                                                                    <span className="invalid-feedback d-block">
                                    {errors.password}
                                  </span>
                                                                )}
                                                            </div>
                                                            <div
                                                                className={
                                                                    showpass
                                                                        ? "passwordContainer"
                                                                        : "passwordContainer show"
                                                                }
                                                            >
                                <span
                                    className="showPasswordIcon"
                                    onClick={() => {
                                        this.showpass();
                                    }}
                                >
                                  <i className="far fa-eye"></i>
                                </span>
                                                                <label>Password*</label>
                                                                <Field
                                                                    type="text"
                                                                    name="password"
                                                                    className="form-control"
                                                                />
                                                                {errors.password && touched.password && (
                                                                    <span className="invalid-feedback d-block">
                                    {errors.password}
                                  </span>
                                                                )}
                                                            </div>
                                                            <div className="text-right mt-2">
                                                                <a href="javascript:void(0);"
                                                                   onClick={this.props.goToForgetPassword}>
                                                                    Forgot password?
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        {!this.state.formSubmitting && (
                                                            <button
                                                                type="submit"
                                                                className="btn btn-round btn-secondary"
                                                            >
                                                                LOGIN
                                                            </button>
                                                        )}
                                                        {this.state.formSubmitting && <Spinner/>}
                                                    </div>
                                                    <div className="form-row f-size">
                                                        <p>
                                                            <em>
                                                                Don't have an account? It's FREE to join so {" "}
                                                                <a href="javascript:void(0);"
                                                                   onClick={this.props.goToSignup}>
                                                                    register Now!
                                                                </a>{" "}
                                                            </em>
                                                        </p>
                                                    </div>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Signin;
